<template>
  <div>
    <ValidationObserver ref="assignWorkerForm" slim>
      <form role="form" @submit.prevent="assign_worker_submit" class="clearfix">
        <div class="row">
          <div class="col-xl-6">
            <h3 class="font-weight-bolder bp_color text-uppercase mb-0">Worker Information</h3>
            <p class="font-weight-bold">Below is information on the worker that you are about to assign.</p>
            <div class="row">
              <div class="col-xl-5"><strong>Full Name:</strong></div>
              <div class="col-xl-7"><span v-if="notEmptyObject(worker) && worker.person !== null">{{
                worker.person.first_name }} {{ worker.person.surname }}</span></div>
              <div class="col-xl-5"><strong>Ref:</strong></div>
              <div class="col-xl-7">
                <span v-if="notEmptyObject(worker) && worker.rel_company_info.company_internal_finance_ref !== null">{{
                  worker.rel_company_info.company_internal_finance_ref
                }}</span>
                <span
                  v-else-if="notEmptyObject(worker) && worker.rel_company_info.company_internal_finance_ref === null">{{
                    worker.internal_finance_ref
                  }}</span>
              </div>
              <div class="col-12">
                <p></p>
              </div>
              <div class="col-xl-5"><strong>Job Title:</strong></div>
              <div class="col-xl-7"><span v-if="notEmptyObject(worker) && worker.rel_profile.job_title_id !== null">{{
                worker.rel_profile.job_title.job_title }}</span></div>
              <div class="col-12">
                <p></p>
              </div>
              <div class="col-xl-5"><strong>Personal Landline:</strong></div>
              <div class="col-xl-7">
                <span v-if="notEmptyObject(phones) && phones.personal_landline !== null">{{
                  phones.personal_landline.phone_number }}</span>
              </div>
              <div class="col-xl-5"><strong>Personal Mobile:</strong></div>
              <div class="col-xl-7">
                <span v-if="notEmptyObject(phones) && phones.personal_mobile !== null">{{
                  phones.personal_mobile.phone_number }}</span>
              </div>
              <div class="col-xl-5"><strong>Email (Website Login):</strong></div>
              <div class="col-xl-7">
                <span v-if="notEmptyObject(emails) && emails.website_login !== null">{{
                  emails.website_login.email_address }}</span>
              </div>
              <div class="col-12" v-if="crmType === 'payroll'">
                <p></p>
              </div>
              <div class="col-12" v-if="crmType === 'payroll'">
                <div class="pa_box"
                  :class="[notEmptyObject(worker) && worker.rel_services.personal_accident_insurance ? 'has_pa' : '']">
                  <span v-if="notEmptyObject(worker) && worker.rel_services.personal_accident_insurance">WORKER HAS PA
                    INSURANCE</span>
                  <span v-else>WORKER HAS NO PA INSURANCE</span>
                </div>
              </div>
            </div>
            <!-- Current Assignments -->
            <div class="row" v-if="current_assignments !== null && current_assignments.length > 0">
              <div class="col-12">
                <hr>
                <h4 class="bp_color text-uppercase">Current Worker Assignments</h4>
              </div>
              <div class="col-12">
                <div class="current_assignments pb-2" v-for="ca in current_assignments">
                  <h5 class="mb-0"><span class="bp_color">{{ ca.order_job.order_ref }}</span> {{ ca.company.company_name
                    }}</h5>
                  <p>{{ ca.order_job.rel_order_location.job_address_full }}</p>
                  <div class="row">
                    <div class="col-lg-8">
                      <p class="mb-0"><strong style="width: 100px;" class="d-inline-block">Job Title:</strong> &nbsp;{{
                        ca.order_job.rel_order_position.job_title }}</p>
                      <p class="mb-2"><strong style="width: 100px;" class="d-inline-block">Job Duration:</strong>
                        &nbsp;{{
                          ca.order_job.rel_order_position.start_date | formatDate
                        }} - {{ ca.order_job.rel_order_position.end_date | formatDate }}
                      </p>
                    </div>
                    <div class="col-md-4">
                      <div class="rd_r_type">{{ ca.position_rate.pay_amount | currency }}</div>
                      <h5 class="mb-0">{{ ca.position_rate.pay_type }} - {{ ca.position_rate.rate_type }} Rate</h5>
                      <!--                      <p class="mb-0">Admin Fee:-->
                      <!--                        <span v-if="ca.position_rate.admin_fee_type === '£ (Pound)'">{{ ca.position_rate.admin_fee_amount | currency }}</span>-->
                      <!--                        <span v-if="ca.position_rate.admin_fee_type === '% (Percentage)'">{{ ca.position_rate.admin_fee_amount | percentage }}</span>-->
                      <!--                      </p>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6" v-if="notEmptyObject(worker) && worker.person !== null && errors.length === 0">
            <b-card :header="'Assign ' + worker.person.first_name + ' ' + worker.person.surname" header-tag="h4"
              body-class="mb-3 pb-2">
              <div class="row" v-if="!loading_companies">
                <div class="col-12">
                  <div style="height: 300px">
                    <loadingCube :loadingMessage="'COMPANIES'"></loadingCube>
                  </div>
                </div>
              </div>
              <div class="row" v-else-if="loading_companies">
                <!-- Company - Multiselect (Validated)-->
                <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Company" tag="div"
                  class="form-group col-xl-12">
                  <label class="form-label" for="company">Company</label>
                  <multiselect v-model="company" id="company" class="requiredField" :class="classes" name="company"
                    placeholder="" :options="ms_opts.companies" label="company_name"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>

                <div class="col-12 mb-3" v-if="company !== null && crmType === 'payroll'">
                  <div class="pa_box" :class="[company !== null && company.payroll_pa_insurance ? 'has_pa' : '']">
                    <span v-if="company.payroll_pa_insurance">COMPANY HAS PA INSURANCE</span>
                    <span v-else>COMPANY DOES NOT HAVE PA INSURANCE</span>
                  </div>
                </div>

                <!-- Job Title - Multiselect (Validated)-->
                <ValidationProvider v-if="company !== null" rules="required" v-slot="{ errors, classes }" name="Job Title"
                  tag="div" class="form-group col-xl-12">
                  <label class="form-label" for="job_title">Job Title</label>
                  <multiselect v-model="job_title" id="job_title" class="requiredField" :class="classes"
                    name="job_title" placeholder="" :options="ms_opts.job_titles" label="job_title"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <div class="col-12" v-if="company !== null && job_title !== null">
                  <hr class="mt-1">
                </div>
                <!-- ORDER INFORMATION -->
                <div class="col-12" v-if="company !== null && job_title !== null">
                  <div class="row">
                    <div class="col-8">
                      <button class="btn orcaBtn w-100" @click.prevent="assign_to_all()">Assign to All</button>
                    </div>
                  </div>

                  <div class="row" v-for="(a, i) in assignments">
                    <div class="col-8">
                      <h5 class="mb-3" style="line-height: 30px">Assignment {{ i + 1 }}</h5>
                    </div>
                    <div class="col-4 text-right">
                      <button v-if="assignments.length > 1" class="orcaBtn sm_btn danger"
                        @click.prevent="remove_assignment(i)"><i class="fas fa-trash"></i> Remove
                      </button>
                    </div>
                    <div class="col-12">
                      <div class="row ml-2">
                        <!-- Orders - Multiselect (Validated) -->
                        <div v-if="loading_order_jobs" class="orders-spinner" aria-live="polite">
                          <div class="dot"></div>
                          <div class="label">Loading orders…</div>
                        </div>
                        <ValidationProvider v-else rules="required" v-slot="{ errors, classes }" :name="'Order ' + i" tag="div"
                          class="form-group col-xl-12">
                          <label class="form-label" :for="'order_' + i">Order</label>
                          <multiselect v-model="a.order" :id="'order_' + i"
                            :class="[classes, company === null ? 'disabled' : 'requiredField']" :name="'order_' + i"
                            placeholder="" :custom-label="cco_label" :option-height="200" :disabled="company === null"
                            :options="ms_opts.orders" :show-labels="false" @select="assignment_order_select">
                            <template slot="singleLabel" slot-scope="props">
                              <span class="font-weight-bold d-inline-block">
                                {{ props.option.order_ref }}</span> - <span class="d-inline-block">{{
                                props.option.job_address_full }}
                              </span>
                            </template>
                            <template slot="option" slot-scope="props">
                              <span class="font-weight-bold d-inline-block">
                                {{ props.option.order_ref }}</span> - <span class="d-inline-block">{{
                                props.option.job_address_full }}
                              </span>
                              <span class="d-block" style="font-size: 0.7rem;">{{ props.option.order_type }}</span>
                            </template>
                          </multiselect>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>

                        <ValidationProvider v-if="a.order !== null" rules="" v-slot="{ errors, classes }"
                          name="Order type" tag="div" class="form-group col-12">
                          <label class="form-label" for="order_type">Order type</label>
                          <input type="text" v-model="a.order.order_type" class="form-input disabled"
                            disabled="disabled" id="order_type" name="order_type" placeholder="Order type">
                        </ValidationProvider>

                        <!-- Rate - Multiselect (Validated) -->
                        <ValidationProvider v-show="a.order !== null" rules="required" v-slot="{ errors, classes }"
                          :name="'Rate ' + i" tag="div" class="form-group col-xl-6">
                          <label class="form-label" :for="'rate_' + i">Rate</label>
                          <multiselect v-model="a.rate" :id="'rate_' + i"
                            :class="[classes, a.order === null ? 'disabled' : 'requiredField']" :name="'rate_' + i"
                            placeholder="" :disabled="a.order === null" :options="a.rates" :custom-label="rate_label"
                            :show-labels="false"></multiselect>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                        <!-- Start Date - Datepicker (Validated) -->
                        <ValidationProvider v-show="a.order !== null" rules="required" v-slot="{ errors, classes }"
                          :name="'Start Date ' + i" tag="div" class="col-xl-3 form-group">
                          <label class="form-label" :for="'start_date_' + i">Start Date</label>
                          <datepicker v-model="a.start_date" :id="'start_date_' + i" :name="'start_date_' + i"
                            :input-class="['date-input', classes, a.order === null ? 'disabled' : 'requiredField']"
                            :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                            :disabled="a.order === null" @input="select_start_date($event, a)" :use-utc="true">
                          </datepicker>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                        <!-- End Date - Datepicker (Validated) -->
                        <ValidationProvider v-show="a.order !== null" rules="" v-slot="{ errors, classes }"
                          :name="'End Date ' + i" tag="div" class="col-xl-3 form-group">
                          <label class="form-label" :for="'end_date_' + i">End Date</label>
                          <datepicker v-model="a.end_date" :id="'end_date_' + i" :name="'end_date_' + i"
                            :input-class="['date-input', classes, a.order === null ? 'disabled' : '']"
                            :format="dateFormat" :clear-button="true" :disabledDates="a.end_date_disabled"
                            clear-button-icon="far fa-calendar-times" :disabled="a.order === null"
                            :calendar-class="'end_date_datepicker'" @input="select_end_date($event, a)" :use-utc="true">
                          </datepicker>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                        <!-- Is gang Leader - Toggle -->
                        <div v-show="a.order !== null" class="col-xl-6 form-group" v-if="!a.is_part_of_gang">
                          <div class="row">
                            <label class="col-md-8 cardLabel" for="is_gang_leader">Is Worker a Gang Leader?</label>
                            <div class="col-md-4">
                              <bootstrap-toggle v-model="a.is_gang_leader" name="is_gang_leader" id="is_gang_leader"
                                :options="{ on: 'Yes', off: 'No' }" @input="input_is_gang_leader($event, a)" />
                            </div>
                          </div>
                        </div>
                        <!-- Is part of gang - Toggle -->
                        <div v-show="a.order !== null" class="col-xl-6 form-group" v-if="!a.is_gang_leader">
                          <div class="row">
                            <label class="col-md-8 cardLabel" for="is_part_of_gang">Is Worker part of a Gang?</label>
                            <div class="col-md-4">
                              <bootstrap-toggle v-model="a.is_part_of_gang" name="is_part_of_gang" id="is_part_of_gang"
                                :options="{ on: 'Yes', off: 'No' }" @input="input_is_part_of_gang($event, a)" />
                            </div>
                          </div>
                        </div>
                        <!-- Gang Leader selection - Multiselect (Validated) -->
                        <div v-show="a.order !== null" v-if="a.is_part_of_gang" class="col-xl-6">
                          <ValidationProvider rules="required" v-slot="{ errors, classes }" :name="'Gang Leader ' + i"
                            tag="div" class="form-group">
                            <label class="form-label" :for="'gang_leader_' + i">Gang Leader</label>
                            <multiselect v-model="a.gang_leader" :id="'gang_leader_' + i" class="requiredField"
                              :class="classes" :name="'gang_leader_' + i" placeholder="" :options="a.gang_leaders"
                              :custom-label="worker_label" :show-labels="false"></multiselect>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-12 pl-0 pr-0">
                    <hr class="mt-2">
                  </div>
                </div>

                <div v-if="ms_opts.orders.length >= 1 && can_add_assignment" class="col-12">
                  <div class="row">
                    <div class="col-lg-7">
                      <p class="font-weight-bold">For Multiple assignments use this button to add another assignment</p>
                    </div>
                    <div class="col-lg-5 form-group">
                      <button @click.prevent="add_assignment" class="orcaBtn greenBtn w-100"><i class="fas fa-plus"></i>
                        &nbsp;
                        Assignment</button>
                    </div>
                  </div>

                  <hr class="mt-0">
                </div>

                <div class="col-12 form-group" v-if="company !== null && job_title !== null">
                  <div class="row">
                    <label class="col-md-8 cardLabel" for="send_ass_email">Send Assignment Email</label>
                    <div class="col-md-4">
                      <bootstrap-toggle v-model="send_ass_email" name="send_ass_email" id="send_ass_email"
                        :options="{ on: 'Yes', off: 'No' }" />
                    </div>
                  </div>
                </div>

                <div class="col-12" v-if="company !== null && job_title !== null">
                  <button type="submit" class="btn orcaBtn w-100" :disabled="saving || (company === null && order === null && rate.length === 0 && assignment.start_date ===
                    null)">
                    <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving Assignment
                      ...</span>
                    <span v-else>Assign</span>
                  </button>
                </div>
              </div>
            </b-card>
          </div>
          <div v-else>
            <h3>Cannot assign worker due to following problems:</h3>
            <div v-for="error in errors">
              <span v-html="error"></span>
            </div>
            <div><button class="btn btn-light" @click="clearErrors">Clear errors</button></div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import BootstrapToggle from 'vue-bootstrap-toggle';
import loadingCube from "loaders/order_loader";

export default {
  name: "worker_assignment",
  components: {Multiselect, Datepicker, BootstrapToggle, loadingCube},
  data() {
    return {
      loading_order_jobs: false,
      loading_companies: false,

      saving: false,
      ms_opts: {
        companies: [],
        job_titles: [],
        original_orders: [],
        orders: [],
      },
      // Worker Information
      worker: {},
      emails: {},
      phones: {},
      // Current assignments for worker
      current_assignments: null,
      // Assignment Information - Single required
      company: null,
      job_title: null,
      send_ass_email: true,
      // Assignment Information - multiple possible
      assignments: [
        {
          order: null,
          rates: [],
          rate: null,
          start_date: null,
          start_date_disabled: {
            to: "",
            from: "",
          },
          end_date: null,
          end_date_disabled: {
            to: "",
            from: "",
          },
          is_gang_leader: false,
          is_part_of_gang: false,
          gang_leaders: [],
          gang_leader: null,
        }
      ],
      can_add_assignment: false,
      errors: []

      //     worker_id: this.$store.state.workers.current_new_assignment.worker_id,
      //     assigned_by_type: 'App\\Models\\Users\\User',
      //     assigned_by_id: this.$store.state.auth.me.id,
      //     // Set log values for creating the worker (current crm user)
      //     log_by_type: 'App\\Models\\Users\\User',
      //     log_by_id: this.$store.state.auth.me.id
    }
  },
  beforeMount() {
    // distinct clients who have live orders
    axios.get(this.crmApiPath + 'assignments/order_job/companies').then(live_order_companies => {
      this.ms_opts.companies = live_order_companies.data
      this.$nextTick(() => this.loading_companies = true)
    });
    // Get worker information and current assignments
    axios.get(this.crmApiPath + 'worker/' + this.$store.state.workers.current_new_assignment.worker_id).then(worker => {
      this.worker = worker.data;
      this.checkBankDetailsComplete();

      axios.get(this.crmApiPath + 'contact_info/email/worker/' + this.$store.state.workers.current_new_assignment.worker_id).then(emails => {
        this.emails = emails.data;
      })
      axios.get(this.crmApiPath + 'contact_info/phone/worker/' + this.$store.state.workers.current_new_assignment.worker_id).then(phones => {
        this.phones = phones.data;
      })

      // get current assignments for the worker
      axios.get(this.crmApiPath + 'assignments/worker/current_assignments/' + this.$store.state.workers.current_new_assignment.worker_id).then(current_assignments => {
        this.current_assignments = current_assignments.data;
      })
    })
  },
  methods: {
    clearErrors() {
        this.errors = [];
    },
    checkBankDetailsComplete() {
      Object.entries(this.worker.bank_details_completion_progress).forEach(([name, state]) => {
        if (!state) {
          let message = "Please update worker bank info: <strong>" + name + "</strong>";
          this.errors.push(message);
        }
      });
    },
    assignment_order_select(val) {
      this.ms_opts.orders = this.ms_opts.original_orders;
      let currently_selected_orders = [];
      this.$nextTick(() => {
        let temp_opts = this.assignments.filter(a => {
          if (a.order !== null) {
            return a;
          }
        })
        currently_selected_orders = temp_opts.map(a => a.order.id);
        this.ms_opts.orders = this.ms_opts.orders.filter(order => currently_selected_orders.indexOf(order.id) === -1)
      })
      this.$nextTick(() => {
        // check for blank orders -> only show add assignment if all filled out
        this.can_add_assignment = this.assignments.length === currently_selected_orders.length;

        let temp = this.assignments.filter(a => {
          if (a.order !== null) {
            return a;
          }
        })
        temp = temp.filter(a => a.order.id === val.id);
        axios.get(this.crmApiPath + 'order/position_rate/all/rates/' + val.id).then(rates => {
          temp[0].rates = rates.data
        });
        // clear rate
        temp[0].rate = null;
        // Start date is today
        temp[0].start_date = this.$moment.utc().format('YYYY-MM-DD');
        // check if there is a timesheet week submitted for the order
        if (temp[0].order.latest_submitted_ts_record !== null) {
          // disable start date to the start date of order
          temp[0].start_date_disabled.to = new Date(this.$moment.utc(temp[0].order.latest_submitted_ts_record.for_work_end_week_date)
            .day(temp[0].order.pay_week_start_day)
            .subtract(7, 'days'));
          // disable end date to day after start date of order
          temp[0].end_date_disabled.to = new Date(this.$moment.utc(temp[0].order.latest_submitted_ts_record.for_work_end_week_date)
            .day(temp[0].order.pay_week_start_day)
            .add(1, 'days'));
        } else {
          // check if there is an open timesheet week
          if (temp[0].order.earliest_open_ts_record !== null) {
            // disable start date to the start date of order
            temp[0].start_date_disabled.to = new Date(this.$moment.utc(temp[0].order.earliest_open_ts_record.for_work_end_week_date)
              .day(temp[0].order.pay_week_start_day)
              .subtract(7, 'days'));
            // disable end date to day after start date of order
            temp[0].end_date_disabled.to = new Date(this.$moment.utc(temp[0].order.earliest_open_ts_record.for_work_end_week_date)
              .day(temp[0].order.pay_week_start_day)
              .add(1, 'days'));
          } else {
            // disable start date to the start date of order
            temp[0].start_date_disabled.to = new Date(this.$moment.utc(val.start_date)
              .day(temp[0].order.pay_week_start_day)
              .subtract(7, 'days'));
            // disable end date to day after start date of order
            temp[0].end_date_disabled.to = new Date(this.$moment.utc(val.start_date)
              .day(val.pay_week_start_day)
              .add(1, 'days'))
              ;
          }
        }

        // end date is -> date end of order
        temp[0].end_date = val.end_date;
        // disable start date from the end date of order
        temp[0].start_date_disabled.from = new Date(this.$moment.utc(val.end_date));
        // disable end date from the end date of order
        temp[0].end_date_disabled.from = new Date(this.$moment.utc(val.end_date));
        // reset gang / leader info
        temp[0].is_gang_leader = false;
        temp[0].is_part_of_gang = false;
        temp[0].gang_leaders = [];
        temp[0].gang_leader = null;
      })
    },

    add_assignment() {
      this.assignments.push({
        order: null,
        rates: [],
        rate: null,
        start_date: null,
        start_date_disabled: {
          to: "",
          from: "",
        },
        end_date: null,
        end_date_disabled: {
          to: "",
          from: "",
        },
        is_gang_leader: false,
        is_part_of_gang: false,
        gang_leaders: [],
        gang_leader: null,
      })
      this.can_add_assignment = false;
    },
    assign_to_all() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Are you sure?</div>' +
          '<div class="snotifyToast__body">' +
          'This will overwrite any assisgnments you may have already partially filled out' +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {

              this.assignments = [];
              for (let i = 0; i < this.ms_opts.orders.length; i++) {
                this.add_assignment();
                let assignment = this.assignments[i];
                assignment.order = this.ms_opts.orders[i];
                this.assignment_order_select(assignment.order);
              }

              this.$snotify.remove(toast.id);
            }
          },
          {text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    remove_assignment(index) {
      this.assignments.splice(index, 1);
      this.$nextTick(() => {
        let currently_selected_orders = [];
        this.$nextTick(() => {
          let temp = this.assignments.filter(a => {
            if (a.order !== null) {
              return a;
            }
          })
          currently_selected_orders = temp.map(a => a.order.id);
          // check for blank orders -> only show add assignment if all filled out
          this.can_add_assignment = this.assignments.length === currently_selected_orders.length;
          if (this.assignments[0].order !== null) {
            this.ms_opts.orders = this.ms_opts.original_orders.filter(order => currently_selected_orders.indexOf(order.id) === -1)
          } else {
            this.ms_opts.orders = this.ms_opts.original_orders
          }
        })
      })
    },
    cco_label({order_ref, job_address_full}) {
      return `${order_ref} - ${job_address_full}`;
    },
    worker_label({worker}) {
      return `${worker.person.first_name} ${worker.person.surname}`;
    },
    rate_label({pay_type, rate_type, pay_amount, admin_fee_type, admin_fee_amount}) {
      let a_fee = '';
      if (admin_fee_type === '£ (Pound)') {
        a_fee = this.$options.filters.currency(admin_fee_amount);
      }
      if (admin_fee_type === '% (Percentage)') {
        a_fee = this.$options.filters.percentage(admin_fee_amount);
      }
      let p_amount = this.$options.filters.currency(pay_amount);

      // return `[${rate_type} : ${pay_type}] ` + p_amount + ` - [Admin Fee : ` + a_fee + `]`;
      return `[${rate_type} : ${pay_type}] ` + p_amount;
    },

    /* Date Format for datepicker */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    // Select actions on datepicker/multiselect
    select_start_date(selected_start_date, assignment) {
      if (selected_start_date != null) {
        assignment.start_date = this.$moment.utc(selected_start_date).format('YYYY-MM-DD');
        assignment.end_date_disabled.to = new Date(this.$moment.utc(selected_start_date));
      }
    },
    select_end_date(selected_end_date, assignment) {
      if (selected_end_date != null) {
        assignment.end_date = this.$moment.utc(selected_end_date).format('YYYY-MM-DD');
      }
    },

    input_is_gang_leader(val, assignment) {
      if (val) {
        assignment.is_part_of_gang = false;
      }
    },
    input_is_part_of_gang(val, assignment) {
      if (!val) {
        assignment.gang_leaders = []
        assignment.gang_leader = null
      }
      else {
        assignment.is_gang_leader = false;
        axios.get(this.crmApiPath + 'assignments/order_job/list_gang_leaders/' + assignment.order.id).then(gang_leaders => {
          assignment.gang_leaders = gang_leaders.data.filter(gl => gl.worker_id !== assignment.worker_id);
        })
      }
    },

    assign_worker_submit() {
      this.$refs.assignWorkerForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.assignWorkerForm);
        }
        else {
          this.saving = true;
          let assign_promises = [];

          let first_name = '';
          let email = '';
          let all_assignments = [];

          // save assignment
          for (let i = 0; i < this.assignments.length; i++) {
            let temp_ass = {
              worker_id: this.worker.id,
              company_id: this.company.id,
              order_job_id: this.assignments[i].order.id,
              position_rate_id: this.assignments[i].rate.id,
              // Set assigned by values for creating the worker (current crm user)
              assigned_by_type: 'App\\Models\\Users\\User',
              assigned_by_id: this.$store.state.auth.me.id,
              start_date: this.assignments[i].start_date,
              end_date: this.assignments[i].end_date,
              assigned: true,
              is_gang_leader: this.assignments[i].is_gang_leader,
              gang_leader_id: null,
              // Set log values for creating the worker (current crm user)
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            };
            if (this.assignments[i].gang_leader !== null) {
              temp_ass.gang_leader_id = this.assignments[i].gang_leader.worker.id;
            }

            assign_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'assignments/worker_assignments', temp_ass).then(() => resolve());
            }))

            first_name = this.worker.person.first_name;
            email = this.emails.website_login.email_address;
            all_assignments.push({ assignment: temp_ass });
          }

          if (this.send_ass_email) {
            // queue assignment email - (with key info doc)
            assign_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'worker/email/all-assignments', {
                first_name: first_name,
                email: email,
                all_assignments: all_assignments
              }).then(() =>
                resolve()
              );
            }))
          }

          Promise.all(assign_promises).then(() => {
            this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.worker.id);
            this.$store.commit('SET_WORKER_TAB_INDEX', 0);
            // // Close current tab and open up profile worker
            this.$nextTick(() => {
              this.saving = false;
              this.$bus.$emit('assignments::reload', { action: true });
              this.$tabs.close({
                path: this.$router.currentRoute.fullPath,
                to: '/workers/profile'
              });
              this.$tabs.refresh('/workers/profile', true);
            })
          })
        }
      });
    }
  },
  watch: {
    company(val) {
      this.job_title = null;
      this.ms_opts.job_titles = [];
      this.ms_opts.original_orders = [];
      this.ms_opts.orders = [];
      this.assignments = [
        {
          order: null,
          rates: [],
          rate: null,
          start_date: null,
          start_date_disabled: {
            to: "",
            from: "",
          },
          end_date: null,
          end_date_disabled: {
            to: "",
            from: "",
          },
          is_gang_leader: false,
          is_part_of_gang: false,
          gang_leaders: [],
          gang_leader: null,
        }
      ];
      if (val !== null) {
        let current_ass_ids = [];
        if (this.current_assignments.length > 0) {
          current_ass_ids = this.current_assignments.map(ca => ca.order_job_id)
        }
        // get job titles for live orders for selected company (for orders not already assigned to)
        axios.post(this.crmApiPath + 'assignments/order_job/company/' + val.id + '/job_titles', {
          'current_ass_ids': current_ass_ids
        }).then(job_titles => this.ms_opts.job_titles = job_titles.data)
      }
      else {
        // reset assignment values method
      }
    },
    async job_title(val) {

      this.can_add_assignment = false;
      this.ms_opts.original_orders = [];
      this.ms_opts.orders = [];
      this.assignments = [
        {
          order: null,
          rates: [],
          rate: null,
          start_date: null,
          start_date_disabled: {to: "", from: ""},
          end_date: null,
          end_date_disabled: {to: "", from: ""},
          is_gang_leader: false,
          is_part_of_gang: false,
          gang_leaders: [],
          gang_leader: null,
        }
      ];

      if (!val) return;

      try {
        this.loading_order_jobs = true;
        let current_ass_ids = [];

        if (this.current_assignments && this.current_assignments.length > 0) {
          current_ass_ids = this.current_assignments.map(ca => ca.order_job_id);
        }

        const res = await axios.get(
            this.crmApiPath + 'assignments/order_job/list_to_assign',
            {
          params: {
                current_ass_ids,
                company_id: this.company.id,
                job_title: val.job_title
              }
          }
        );



        // maps
        const wMapper = {
            'PAYE': 'PAYE',
            'Temporary (PAYE)': 'PAYE',
            'Self Employed (CIS) - Sole Trader': 'Contract',
            'Self Employed - Sole Trader': 'Contract',
            'Limited Company': 'Contract'
          };

        const oMapper = {
            'Contract': ['Contract'],
            'Internal': ['N/A'],
            'Payroll - Contract': ['Contract'],
            'Payroll - PAYE': ['PAYE'],
            'Permanent': ['Contract', 'PAYE'],
            'Temporary (PAYE)': ['PAYE']
          };

        const workerType =
            wMapper[this.worker.rel_company_info.employment_type.value] ?? 'N/A';

        res.data.forEach(order => {
          const orderTypes = oMapper[order.order_type] ?? [];
            if (orderTypes.includes(workerType)) {
                this.ms_opts.original_orders.push(order);
                this.ms_opts.orders.push(order);
            }
          });

          if (this.ms_opts.original_orders.length === 0) {
              this.errors.push('There are no orders fitted for this worker.');
          }

        this.loading_order_jobs = false;

      } catch (err) {
        this.loading_order_jobs = false;
        console.error('Error loading orders for job title:', err);
        this.$snotify?.error('Unable to load orders', 'Error');
      }
    }
  }
}
</script>
<style lang="scss">
.end_date_datepicker {
  right: 0;
}
</style>
<style scoped lang="scss">
.pa_box {
  text-align: center;
  padding: 5px;
  background: $red;
  color: $white;

  &.has_pa {
    background: $green;
  }
}

.current_assignments {
  background: $card_background;
  padding: 15px;
  margin-bottom: 20px;

  .rate_desc,
  .rate_admin_fee {
    display: inline-block;
    vertical-align: middle;
  }

  //.rate_desc {
  //  margin-right: 15px;

  .rd_r_type {
    font-weight: bold;
    font-size: 1rem;
    color: $bc_1;
    line-height: 1.1;
  }

  //}

  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
